




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {State} from "vuex-class";

@Component({})
export default class ZaposleniPripadnostEditor extends Vue {
    @State zaposleni!: [];
    @Prop() value!: string;
    @Prop() parent!: string;
    @Prop({default: false}) invalid!: boolean;

    model = '';

    @Watch("value") onValueChange(value) {
        this.model = value;
    }

    @Watch("model") onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {}

    async created() {
        this.model = this.value;
    }

    options = {
        templateResult: this.render,
        templateSelection: this.render,
    };

    render(data: any) {
        if (!data.slika) {
            return $(`<p style="background: url(${'images/userImage.jpg'}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
        } else {
            return $(`<p style="background: url(${data.slika}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
        }
    }

}
